import { render } from "./Idea.vue?vue&type=template&id=653c948e&scoped=true"
import script from "./Idea.vue?vue&type=script&lang=js"
export * from "./Idea.vue?vue&type=script&lang=js"

import "./Idea.vue?vue&type=style&index=0&id=653c948e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-653c948e"

export default script